module.exports = __webpack_public_path__ + "img/cardN.08f04da1.png";